export default "__VITE_ASSET__B6pI9MJ0__"